import { BlogPostContent } from '@/types/blog';
import { introSection } from './sections/intro';
import { howItWorksSection } from './sections/how-it-works';
import { advantagesSection } from './sections/advantages';
import { limitationsSection } from './sections/limitations';
import { collaborationSection } from './sections/collaboration';
import { conclusionSection } from './sections/conclusion';
import { ctaSection } from './sections/cta';

export const content: BlogPostContent = {
  sections: [
    introSection,
    howItWorksSection,
    advantagesSection,
    limitationsSection,
    collaborationSection,
    conclusionSection,
    ctaSection
  ]
};
